import { useQuery } from '@tanstack/react-query';
import { useAgentRuntime } from '../context/AgentProvider';
import type { ModelOption } from '@multiplayer-app/ai-agent-types';

export const useModels = () => {
  const runtime = useAgentRuntime();

  const query = useQuery({
    queryKey: ['mp-agents', 'models'],
    queryFn: async (): Promise<ModelOption[]> => {
      if (runtime.transport.listModels) {
        return await runtime.transport.listModels();
      }
      // Fallback to empty array if transport doesn't support listModels
      return [];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false
  });

  return query;
};
